<template>
    <div class="form_group form_group_officer">
        <display-message :option="message_option"></display-message>
        <div class="form_row">
            <label :for="'officer_'+current_officer_id+'_contact_id'" v-html="cache_data_label.contact_id" v-show="cache_data.contact_id"></label>
            <div class="select_container" v-show="!current_contact_id">
                <select :id="'officer_'+current_officer_id+'_contact_id'" v-model="cache_data.contact_id" :placeholder="cache_data_label.contact_id" @change="current_contact_id = (cache_data.contact_id=='Add New'?'new':'')">
                    <option value="" disabled>-- {{ cache_data_label.contact_id }} --</option>
                    <option :value="contact.id" v-for="contact in item_list.contacts" v-if="contact.contact_type == 'People'">{{ contact.formatted_name }}</option>
                    <option value="Add New">Add New</option>
                </select>
            </div>
            <p style="display:block;margin:0;padding: 0.5em 0 0.5em 1em;font-size: 0.8em;" v-show="!current_contact_id && cache_data.contact_id && cache_data.contact_id != 'Add New'"><a style="font-size: 1.25em;text-decoration: underline;" href="javascript:void(0)" @click="current_contact_id = cache_data.contact_id">Click here to edit officer details</a> Note: Editing details will change them anywhere else these details are used</p>
        </div>
        <update-contact v-show="current_contact_id" :current_contact_id="current_contact_id" @submit="change_contact" :option="{item_list:item_list,item_map:item_map,contact_id:'officer_'+current_officer_id,contact_for:'officer'}"></update-contact>
        <div class="form_row">
            <label :for="'officer_'+current_officer_id+'_position'"v-html="cache_data_label.position" v-show="cache_data.position"></label>
            <div class="select_container">
                <select :id="'officer_'+current_officer_id+'_position'" :placeholder="cache_data_label.position" v-model="cache_data.position">
                    <option value="" disabled>-- {{ cache_data_label.position }} --</option>
                    <option value="Director">Director</option>
                    <option value="Secretary">Secretary</option>
                    <option value="Director and Secretary">Director and Secretary</option>
                </select>
            </div>
        </div>
        <div class="form_row" v-show="$root.panel === 'admin'">
            <label :for="'officer_'+current_officer_id+'_signatory_status'"v-html="cache_data_label.signatory_status" v-show="cache_data.signatory_status"></label>
            <div class="select_container">
                <select :id="'officer_'+current_officer_id+'_signatory_status'" :placeholder="cache_data_label.signatory_status" v-model="cache_data.signatory_status">
                    <option value="" disabled>-- {{ cache_data_label.signatory_status }} --</option>
                    <option value="Attendee">Attendee</option>
                    <option value="Signatory">Signatory</option>
                    <option value="Chairperson">Chairperson</option>
                    <option value="Form Signatory">Form Signatory</option>
                    <option value="Apology">Apology</option>
                    <option value="Non Attendee">Non Attendee</option>
                </select>
            </div>
        </div>
        <div class="form_row form_row_controller_container" v-show="!current_contact_id">
            <input type="button" class="btn btn-primary" value="Save" @click="save()">
            <input type="button" class="btn btn-secondary-inverse" value="Cancel" @click="cancel()">
<!--            <input type="button" class="btn btn-secondary-inverse" value="Remove" @click="remove()" v-show="current_officer.id">-->
        </div>
    </div>    
</template>

<script>
    export default {
        name: "UpdateOfficer",
        props: ['current_officer_id','option'],
        data() {
            let data_set = {
                current_contact_id: '',
                cache_data_label: {
                    contact_id: 'Officer Details',
                    position: 'Position',
                    signatory_status: 'Meeting Status'
                },
                // cache_data: {
                //     contact_id: '',
                //     position: '',
                //     signatory_status: ''
                // },
                message_option: {
                    message: '',
                    message_type: ''
                },
            };
            let current_object = this;
            data_set.cache_data = current_object.reset_cache_data({init:true});
            Object.keys(current_object.option).forEach(function (option_key) {
                data_set[option_key] = current_object.option[option_key];
            });
console.log('init UpdateOfficer',data_set);

            // data_set.officer_id = data_set.current_officer_id;
            if (data_set.item_map && data_set.item_map.officers[current_object.current_officer_id]) {
                data_set.current_officer = data_set.item_map.officers[current_object.current_officer_id];
            } else {
                data_set.current_officer = {}
            }
            //
            // if (data_set.current_officer && data_set.current_officer.id) {
            //     data_set.officer_id = data_set.current_officer.id;
            //     data_set.cache_data = Object.assign(data_set.cache_data,data_set.current_officer);
            // } else {
            //     data_set.officer_id = 'new';
            // }

            return data_set;
        },
        methods: {
            // display_message: function(message,option) {
            //     this.$root.display_message(message,this.message_option,option);
            // },
            reset_cache_data: function(option) {
                if (typeof option === 'undefined') {
                    option = {};
                }

                let current_object = this;

                let cache_data = {};
                if (!option.init) {
                    cache_data = current_object.cache_data;
                }

                cache_data.id = '';
                cache_data.contact_id = '';
                cache_data.position = '';
                cache_data.signatory_status = 'Attendee';

                current_object.current_officer = {};
                if (current_object.current_officer_id && current_object.option) {
                    if (current_object.option.item_map.officers[current_object.current_officer_id]) {
                        cache_data = Object.assign(cache_data, current_object.item_map.officers[current_object.current_officer_id]);
                        current_object.current_officer = current_object.item_map.officers[current_object.current_officer_id];
                    }
                }
                return cache_data;

            },
            change_contact: function(contact_id) {
                if (!contact_id) {
                    this.cache_data.contact_id = '';
                } else {
                    this.cache_data.contact_id = contact_id;
                }
                this.current_contact_id = '';
            },
            save: function () {
                let current_object = this;

                let warning_message = [];

                // General Validation, e.g. mandatory field empty, number format wrong...
                Object.keys(current_object.cache_data).forEach(function (field_name) {
                    switch (field_name) {
                        case 'contact_id':
                            if (current_object.cache_data[field_name] === '' || current_object.cache_data[field_name] === 'Add New') {
                                warning_message.push('Field "'+current_object.cache_data_label[field_name]+'" is required.');
                            }
                            break;
                        case 'position':
                        // case 'signatory_status':
                            if (current_object.cache_data[field_name] === '') {
                                warning_message.push('Field "'+current_object.cache_data_label[field_name]+'" is required.');
                            }
                            break;
                    }
                });
                let current_contact = current_object.item_map.contacts[current_object.cache_data.contact_id];
                if (!current_contact) {
                    warning_message.push('Officer '+current_object.cache_data_label['contact_id']+' missing.');
                } else {
                    // mandatory_fields.push('birthday');
                    // mandatory_fields.push('birth_country');
                    // mandatory_fields.push('birth_state');
                    // mandatory_fields.push('birth_place');
                    if (!current_contact.birthday || !current_contact.birth_country || !current_contact.birth_state || !current_contact.birth_place) {
                        warning_message.push('Officer '+current_contact.formatted_name+' birth details incomplete, please update contact detail to complete them.');
                    }
                    if (current_object.cache_data.position.indexOf('Director') > -1) {
                        if (!current_contact.director_id) {
                            warning_message.push('Officer '+current_contact.formatted_name+' is set as director. Director ID is required.');
                        }
                    }

                }

                if (warning_message.length > 0) {
                    // current_object.display_message(warning_message,{message_type:'error'});
                    current_object.message_option.message_type = 'error';
                    current_object.message_option.message = warning_message;
                    return false;
                } else {
                    // current_object.display_message('');
                    current_object.message_option.message_type = 'success';
                    current_object.message_option.message = '';
                }

                if (!current_object.current_officer.id) {
                    current_object.current_officer = Object.assign(current_object.current_officer,current_object.cache_data);
                    let index_counter = 1;
                    while (current_object.item_map.officers['new_'+index_counter]) {
                        index_counter++;
                    }

                    current_object.current_officer.id = 'new_'+index_counter;

                    current_object.item_map.officers[current_object.current_officer.id] = current_object.current_officer;
                    current_object.item_list.officers.push(current_object.current_officer);
                } else {
                    current_object.current_officer = Object.assign(current_object.current_officer,current_object.cache_data);
                    // current_object.item_map.officers[current_object.current_officer.id] = Object.assign(current_object.item_map.officers[current_object.current_officer.id],current_object.current_officer);
                }
                $('html, body').stop().animate({
                    scrollTop:$(current_object.$el).offset().top - 200
                }, 550, 'swing', function () {
                    // When message box display for the first time, container does not exist and scroll to position would be the bottom of container instead of top
                    // (calculated top position number is correct, it is kind of browser render problem)
                    // Do scrollTop again after 0.5s (vue fade-in animate time by css) would fix the problem
                    // scrollTop:$(current_object.$el).offset().top - 200;
                });
                current_object.$emit('update:current_officer_id',null);
console.log('allen debug UpdateOfficer submit', current_object.current_officer, current_object.current_officer_id);
                current_object.reset_cache_data();
console.log('allen debug UpdateOfficer submit 2', current_object.current_officer, current_object.current_officer_id);
                // current_object.$emit('update:item_list.officers',current_object.item_list.officers);
                return current_object.current_officer;
            },
            cancel: function () {
                let current_object = this;

                // Erase error message if applicable
                current_object.message_option.message_type = '';
                current_object.message_option.message = '';
                $('html, body').stop().animate({
                    scrollTop:$(current_object.$el).offset().top - 200
                }, 550, 'swing', function () {
                    // When message box display for the first time, container does not exist and scroll to position would be the bottom of container instead of top
                    // (calculated top position number is correct, it is kind of browser render problem)
                    // Do scrollTop again after 0.5s (vue fade-in animate time by css) would fix the problem
                    // scrollTop:$(current_object.$el).offset().top - 200;
                });
                current_object.$emit('update:current_officer_id',null);
            },
            remove: function () {
                let current_object = this;
                if (current_object.item_map.officers[current_object.current_officer.id]) {
                    if (current_object.current_officer.id.match(/^new_/)) {
                        delete current_object.item_map.officers[current_object.current_officer.id];
                    } else {
                        current_object.item_map.officers[current_object.current_officer.id].deleted = true;
                    }
                    // delete current_object.item_map.officers[current_object.current_officer.id];
                }
                let item_list_index = current_object.item_list.officers.indexOf(current_object.current_officer);
                if (item_list_index > -1) {
                    current_object.item_list.officers.splice(item_list_index,1);
                }

                current_object.message_option.message_type = '';
                current_object.message_option.message = '';

                current_object.$emit('update:current_officer_id',null);
                // current_object.$emit('update:item_list.officers',current_object.item_list.officers);
            }
        },
        watch: {
            current_officer_id: function (new_officer_id, old_officer_id) {
                let current_object = this;

                current_object.reset_cache_data();
                current_object.message_option.message = '';
                current_object.message_option.message_type = '';
            }
        }
    }
</script>